import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PageNavigation = () => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
      <Button
        onClick={goBack}
        size="icon"
        variant="outline"
        className="rounded-full w-12 h-12 bg-card/90 backdrop-blur-sm border-border hover:bg-primary hover:text-primary-foreground shadow-lg transition-all duration-300 hover:scale-110"
        aria-label="Voltar para página anterior"
      >
        <ArrowLeft className="w-5 h-5" />
      </Button>
      <Button
        onClick={scrollToTop}
        size="icon"
        variant="outline"
        className="rounded-full w-12 h-12 bg-card/90 backdrop-blur-sm border-border hover:bg-primary hover:text-primary-foreground shadow-lg transition-all duration-300 hover:scale-110"
        aria-label="Voltar ao topo"
      >
        <ArrowUp className="w-5 h-5" />
      </Button>
    </div>
  );
};

export default PageNavigation;
